export default function initOrdenacaoBlog() {
    const gridPosts = document.querySelector('.c-novidades__grid');
    const selectOrdem = document.getElementById('js-select-ordem');
    const viewBtns = document.querySelectorAll('.c-view-switcher__btn');
    const secaoConteudo = document.getElementById('flt-posts');

    
    // --- FUNÇÃO PARA ROLAR ---
   const checkScrollNeeded = () => {
    if (sessionStorage.getItem('scroll_to_grid') === 'true' && secaoConteudo) {
        const offset = 100; 

        setTimeout(() => {
            const bodyRect = document.body.getBoundingClientRect().top;
            const elementRect = secaoConteudo.getBoundingClientRect().top;
            const elementPosition = elementRect - bodyRect;
            const offsetPosition = elementPosition - offset;

            window.scrollTo({
                top: offsetPosition,
                behavior: 'smooth'
            });

            sessionStorage.removeItem('scroll_to_grid');
        }, 300);
    }
};

    if (!gridPosts || !selectOrdem) return;

    function ordenarPosts() {
        const posts = Array.from(gridPosts.querySelectorAll('.c-card-post'));
        const modo = selectOrdem.value;

        posts.sort((a, b) => {
            if (modo === 'alpha') {
                const tituloA = a.querySelector('.c-card-post__title').innerText.toLowerCase();
                const tituloB = b.querySelector('.c-card-post__title').innerText.toLowerCase();
                return tituloA.localeCompare(tituloB);
            }

            if (modo === 'newest' || modo === 'oldest') {
                const idA = parseInt(a.id.replace('post-', ''));
                const idB = parseInt(b.id.replace('post-', ''));
                return modo === 'newest' ? idB - idA : idA - idB;
            }
        });

        gridPosts.innerHTML = '';
        posts.forEach(post => gridPosts.appendChild(post));
    }

    function setViewLayout(numCols) {
        gridPosts.setAttribute('data-layout-cols', numCols);
        
        viewBtns.forEach(btn => {
            const btnCols = btn.getAttribute('data-columns');
            btn.classList.toggle('is-active', btnCols === numCols.toString());
        });
        
        localStorage.setItem('pref-cols', numCols);
    }

    function checkInitialLayout() {
        const urlParams = new URLSearchParams(window.location.search);
        const colParam = urlParams.get('columns');
        const isMobile = window.innerWidth <= 768;

        if (colParam) {
            setViewLayout(colParam);
        } else {
            const defaultCol = isMobile ? '1' : '3';
            setViewLayout(defaultCol);
        }
    }

    viewBtns.forEach(btn => {
        btn.addEventListener('click', (e) => {
            e.preventDefault();
            sessionStorage.setItem('scroll_to_grid', 'true');

            const numCols = btn.getAttribute('data-columns');
            const url = new URL(window.location.href);
            url.searchParams.set('columns', numCols);
            url.searchParams.set('paged', '1'); 
            
            window.location.href = url.toString();
        });
    });

    selectOrdem.addEventListener('change', ordenarPosts);

    checkScrollNeeded();

    checkInitialLayout();
}